// @flow

export const MODEL = 'Comments'
export const TREE = 'commentsData'
export const BRANCH = 'comments'
// Api End Point
export const URL = 'hefty/comment/'

// Model Properties
export const PROP_ID = 'id'
export const PROP_FIELD = 'field'
export const PROP_CROP = 'crop'
export const PROP_YIELD_TARGET = 'yield_target'
export const PROP_DATA = 'data'
export const PROP_DATE_CREATED = 'date_created'
export const PROP_YIELD_GOAL = 'yield_goal'
